var CALENDAR_MONTH_PADDING = 9;
export default function getCalendarMonthWidth(daySize) {
  var monthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_MONTH_PADDING;
  return 7 * (daySize + 1) + 2 * (monthPadding + 1);
}